<template>
  <div>
    <!-- <flexbox :gutter="0" style="height: 50px; background-color: #FFFFFF;">
      <flexbox-item :span="8">
       <span class="mx-3">
          <span>{{$t('cart.totalPrice')}}</span>
        <b style="color: red">{{$t('kol.priceUnit')}} {{getExchangePrice( totalPrice )}}</b> <small style="color: gray">({{$t('cart.noTariff')}})</small>
        </span>
      </flexbox-item>
      <flexbox-item>
        <b-button variant="success" class="footer-button2" block @click="$router.push('/cart/checkout')">{{$t('cart.checkout')}}</b-button>
      </flexbox-item>
    </flexbox> -->


      <b-row class="mx-0" :gutter="0" style="height: 50px; background-color: #FFFFFF;">
      <b-col class="px-0" cols="8">
       <span class="cartFooterText mx-3">
          <span>{{$t('cart.totalPrice')}}</span>
        <b style="color: red">{{$t('kol.priceUnit')}} {{ totalPrice }}</b> <small style="color: gray">({{$t('cart.noTariff')}})</small>
        </span>
      </b-col>
      <b-col class="px-0" cols="4">
        <b-button variant="success" class="footer-button2 " @click="goToCheckout">{{$t('cart.checkout')}}</b-button>
      </b-col>
    </b-row>

  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
import { Flexbox, FlexboxItem, XButton } from 'vux'

export default {
  name: 'CartFooter',
  components: {
    Flexbox,
    FlexboxItem
  },
  props: {
    totalPrice: Number,
    currency: String
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters([
      'getExchangePrice',
    ]),
    cartProducts() {
      return this.$store.state.cartProducts;
    },
  },
  methods: {
    goToCheckout(){
      if(this.cartProducts<1){
        return; 
      }
      this.$router.push('/cart/checkout')
    }
  },
}

</script>
<style type="text/css" scoped>
.footer-button2 {
  height: 50px;
  border-radius: 0px;
  font-size: 20;
  z-index: 200;
  width: 100% !important;
}
.cartFooterText{
  line-height: 50px !important;
}

</style>



// WEBPACK FOOTER //
// src/Cart/components/CartFooter.vue